import {Filter} from '@shared/models/filter.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {ContractDetailsModel} from '@cc-commons/models/contract-details.model';


export class ContractsFilterModel extends Filter {
	public static veh_types: string[] = ['Undefined', 'Passenger Car', 'Light Commercial Vehicle', 'Heavy Commercial Vehicle', 'Motorcycle', 'Scooter', 'Ciclomotore', 'Quadriciclo'];

	public static contract_types: string[] = ['EXCHANGE1', 'EXCHANGE2', 'RETURN'];

	public static contract_status_for_spo_from_closed = ContractDetailsModel.CLOSED + ',' + ContractDetailsModel.REBILLABLE + ',' + ContractDetailsModel.REBILLABLE_IN_WORKING + ',' + ContractDetailsModel.REBILLABLE_IN_REVIEW + ',' + ContractDetailsModel.REBILLABLE_CLOSED;
	public static contract_status_for_spo: string[] = [ContractDetailsModel.NO_SHOW, ContractDetailsModel.APPOINTMENT_REQUIRED, ContractDetailsModel.APPOINTMENT_CONFIRMED,
		ContractDetailsModel.READY_FOR_SURVEY, ContractDetailsModel.WITH_SURVEY, ContractsFilterModel.contract_status_for_spo_from_closed];

	public static contract_states_for_dko_from_with_survey = ContractDetailsModel.WITH_SURVEY + ',' + ContractDetailsModel.CLOSED + ',' + ContractDetailsModel.REBILLABLE + ',' + ContractDetailsModel.REBILLABLE_IN_WORKING + ',' + ContractDetailsModel.REBILLABLE_IN_REVIEW + ',' + ContractDetailsModel.REBILLABLE_CLOSED;
	public static contract_status_for_dko: string[] = [ContractDetailsModel.NO_SHOW, ContractDetailsModel.APPOINTMENT_CONFIRMED, ContractDetailsModel.READY_FOR_SURVEY, ContractsFilterModel.contract_states_for_dko_from_with_survey];

	public static contract_status_for_ald_part_1 = [ContractDetailsModel.NO_SHOW, ContractDetailsModel.APPOINTMENT_REQUIRED, ContractDetailsModel.APPOINTMENT_CONFIRMED + ',' + ContractDetailsModel.READY_FOR_SURVEY + ',' + ContractDetailsModel.WITH_SURVEY];
    public static contract_status_for_bo = [ContractDetailsModel.REBILLABLE, ContractDetailsModel.REBILLABLE_IN_WORKING, ContractDetailsModel.REBILLABLE_IN_REVIEW + ',' + ContractDetailsModel.REBILLABLE_CLOSED];

	public static closure_types: string[] = [ContractDetailsModel.CLOSURE_WITH_SURVEYOR, ContractDetailsModel.CLOSURE_WITHOUT_SURVEYOR, ContractDetailsModel.CLOSURE_WITH_TEMPLATE];

	public static contract_status_for_ald_from_closed = ContractDetailsModel.CLOSED;

	contract_number: string;
	plate: string;
	client_code: string;
	redelivery_office: string;
	contract_type: string;
	closure_type: string;
	contract_status: string;
	redelivery_digitally_signed: string;
	closed_from: string;
	closed_to: string;
	search_field: string;
	driver: string;
	company: string;
	redelivery_status: string;
	vehicle_type: string;
	redelivery_from: string;
	redelivery_to: string;

	contract_expiration: string;
	surveyor: string;
	ald_supplier_id: string;
	ald_supplier_label: string;
	pick_up_at_the_office: boolean;
	home_closing: boolean;
	reactive: boolean;

	constructor(model?: ContractsFilterModel) {
		super();
		if (!Utilities.isVoid(model)) {
			
			Object.assign(this, model);
			
			if (!Utilities.isVoid(model.closed_from)) {
				this.closed_from = model.closed_from;
			}

			if (!Utilities.isVoid(model.closed_to)) {
				this.closed_to = model.closed_to;
			}

			if (!Utilities.isVoid(model.redelivery_from)) {
				this.redelivery_from = model.redelivery_from;
			}
			
			if (!Utilities.isVoid(model.redelivery_to)) {
				this.redelivery_to = model.redelivery_to;
			}
		}
	}

	newFilter(model?: any): Filter {
		return new ContractsFilterModel( this.trimFilter(model) );
	}

	clone(): ContractsFilterModel {
		return new ContractsFilterModel(this);
	}

	public getFilterUrl(): string {
		let filterUrl = Utilities.getQuery(this);
		if (!Utilities.isVoid(this.redelivery_from) && Utilities.isVoid(this.redelivery_to)) {
			filterUrl += '&redelivery_to=2099-12-31T22:59:59Z';
		}
		if (!Utilities.isVoid(this.redelivery_to) && Utilities.isVoid(this.redelivery_from)) {
			filterUrl += '&redelivery_from=1900-01-01T00:00:00Z';
		}
		if (!Utilities.isVoid(this.closed_from) && Utilities.isVoid(this.closed_to)) {
			filterUrl += '&closed_to=2099-12-31T22:59:59Z';
		}
		if (!Utilities.isVoid(this.closed_to) && Utilities.isVoid(this.closed_from)) {
			filterUrl += '&closed_from=1900-01-01T00:00:00Z';
		}
		return filterUrl;
	}
	
	private trimFilter(model: any): any {
		
		// Trim su tutti i campi
		Object.keys(model).forEach(x => {
			if (typeof model[x] === 'string') {
				model[x] = model[x].trim()
			}
		});
		
		return model;
	}
}
